import React from 'react';
import { SvgIcon } from '@mui/material';

import { PALETTE } from '../theme/palette';

export default function LoadingSpinnerIcon(props) {
  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <g clipPath="url(#clip0_5326_49534)">
          <path
            d="M16 1.93384V6.62134"
            stroke={PALETTE.BLUE_STATUS}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 30.0588V25.3713"
            stroke={PALETTE.BLUE_STATUS}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.05664 6.05249L9.37164 9.36749"
            stroke={PALETTE.BLUE_STATUS}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.9439 25.94L22.6289 22.6262"
            stroke={PALETTE.BLUE_STATUS}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.9375 15.9963H6.625"
            stroke={PALETTE.BLUE_STATUS}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.0625 15.9963H25.375"
            stroke={PALETTE.BLUE_STATUS}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.05664 25.94L9.37164 22.6262"
            stroke={PALETTE.BLUE_STATUS}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.9439 6.05249L22.6289 9.36749"
            stroke={PALETTE.BLUE_STATUS}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5326_49534">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
